/**
 * Vrai sous un `<ScreenBackground>` : l'écran a déjà son fond, peint par la coquille. Lu par
 * `<PageTemplate>`, qui ne pose alors plus le sien — il couvrirait la lueur.
 */
import { createContext } from "react"

export const ScreenPaintedContext = createContext(false)
